export default {"src":"/_next/static/media/ray.b5851656.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};